import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { getUserProfile } from '../../user-profile/actions/user-profile-actions';
import { getUserBalance } from '../../payments/actions/payment-actions';
import { toggleMenu } from '../actions/layout-actions';
import RenderIf from '../../../shared/render-if/components/render-if';
import HeaderProfileSection from './header-profile-section';
import HeaderBalanceSection from './header-balance-section';
import LanguagesPicker from './languages-picker';

import nagaLogo from '../../../../common/images/naga-logo-big.png';

import '../styles/header.css';

class Header extends Component {
  componentDidMount() {
    const { profile, getUserProfile, getUserBalance, userBalance } = this.props;

    if (!profile) {
      getUserProfile();
    }

    if (!userBalance) {
      getUserBalance();
    }
  }

  toggleMenu() {
    const { showMenu, toggleMenu } = this.props;

    toggleMenu(!showMenu);
  }

  render() {
    const { profile, userBalance } = this.props;

    return (
      <div className="header-container">
        <div className="row">
          <div className="col-md-4 header-container__left-part">
            <img src={nagaLogo} className="header-container__left-part__logo" alt="Naga Logo" />
            <RenderIf if={profile}>
              <HeaderProfileSection profile={profile} />
            </RenderIf>
          </div>
          <div className="col-md-8 header-container__right-part">
            <span className="glyphicon glyphicon-menu-hamburger pull-right header-container__right-part__menu-icon" onClick={() => this.toggleMenu()} />
            <LanguagesPicker />
            <RenderIf if={userBalance}>
              <HeaderBalanceSection userBalance={userBalance} />
            </RenderIf>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  profile: state.userProfileReducer.profile,
  userBalance: state.paymentsReducer.userBalance,
  showMenu: state.layoutReducer.showMenu,
});

const mapDispatchToProps = dispatch => ({
  getUserProfile: () => {
    dispatch(getUserProfile());
  },
  getUserBalance: () => {
    dispatch(getUserBalance());
  },
  toggleMenu: show => {
    dispatch(toggleMenu(show));
  },
});

Header.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/app/main/layout/components/header.js